import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

interface ExportableCar {
  name: string;
  model: string;
  engine: string;
  plate: string;
  status: string;
  "BT Rate": string;
  "Eastern Rate": string;
  "Central Rate": string;
  "Northern Rate": string;
}

export function exportCarsToExcel(data: ExportableCar[]) {
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Cars");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const file = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(file, "car-list.xlsx");
}
